// Copyright (c) 2026 Deere & Company

import actions from '../../actions-list';

export const setRgaResultsNavigation = resultsNavigation => ({
    resultsNavigation,
    type: actions.UPDATE_RGA_RESULTS_NAVIGATION
});

export const resetRgaResultsNavigation = () => ({
    type: actions.RESET_RGA_RESULTS_NAVIGATION
});



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/results-navigation.js